export interface IProduct_MasterView {
    Id: number,
    ItemType: number,
    ItemCode: string,
    RefNo: string,
    Name: string,
    ShortName: string,
    DeptId: number,
    CatId: number,
    SubCatId: number,
    BrandId: number,
    UnitId: number,
    ColorId: number,
    SizeId: number,
    PackingQty: string,
    CostPrice: number,
    SellingPrice: number,
    AvgCost: number,
    LastPurCost: number,
    StkQty: number,
    Margin: number,
    MarginPer: number,
    Barcode: string,
    ItemImagepath: string,
    ItemImageBinary: object,
    SecLanguage: string,
    IsRowMaterial: boolean,
    IsStockItem: boolean,
    IsWeightItem: boolean,
    IsActive: boolean,
    UserId: number,
    supplier: number,
    Taxcode: number,
    TaxRate: number,
    Alternateunit: IAlternateunit[],
    ItemControl: IItemControl[],
    OrderLevel: IOrderLevel[],
    Supplieritem: ISupplieritem[],
    SellingPriceList: ISellingPriceList[],
    IsExpiry:boolean,
    IsSerialItem:boolean,
    IsCalculateStock:boolean,
    ImageWidth:number,
    ImageHeight:number
}
export interface IAlternateunit {
    ID: number,
    description: string,
    unitid: number,
    conversion: string,
    costprice: number,
    sellingprice: number,
    barcode: string,
    itemimagePath: string,
    itemimagebinary: object,
    secondarylanguagename: string,
    Unit: string
}
export interface IItemControl {
    ID: number,
    barcode: string,
    locationid: number,
    allowpurchase: boolean,
    allowsales: boolean,
    allowtransin: boolean,
    allowtransout: boolean
}
export interface IOrderLevel {
    ID: number,
    barcode: string,
    location: number,
    minimumlevel: number,
    reorderlevel: number,
    reorderqty: number
}
export interface ISupplieritem {
    ID: number,
    barcode: string,
    branchid: number,
    supplierid: number,
    supplieritemcode: string,
    costprice: number
}
export interface ISellingPriceList {
    ID: number,
    barcode: string,
    sellingpricelevelid: number,
    sellingprice: number
}
export interface IDuplicateBarcode {
    Barcode: string[],
    ItemTypeId: number,
    isEdit: boolean
}
export class Product_MasterView_Model implements IProduct_MasterView {
    Id: number;
    ItemType: number;
    ItemCode: string;
    RefNo: string;
    Name: string;
    ShortName: string;
    DeptId: number;
    CatId: number;
    SubCatId: number;
    BrandId: number;
    UnitId: number;
    ColorId: number;
    SizeId: number;
    PackingQty: string;
    CostPrice: number;
    SellingPrice: number;
    AvgCost: number;
    LastPurCost: number;
    StkQty: number;
    Margin: number;
    MarginPer: number;
    Barcode: string;
    ItemImagepath: string;
    ItemImageBinary: object;
    SecLanguage: string;
    IsRowMaterial: boolean;
    IsStockItem: boolean;
    IsWeightItem: boolean;
    IsActive: boolean;
    UserId: number;
    supplier: number;
    Taxcode: number;
    TaxRate: number;
    Alternateunit: IAlternateunit[];
    ItemControl: IItemControl[];
    OrderLevel: IOrderLevel[];
    Supplieritem: ISupplieritem[];
    SellingPriceList: ISellingPriceList[];
    IsExpiry:boolean;
    IsSerialItem:boolean;
    IsCalculateStock:boolean;
    ImageWidth:number;
    ImageHeight:number;

    constructor() {
        this.Id = 0;
        this.ItemType = 0;
        this.ItemCode = "";
        this.RefNo = "";
        this.Name = "";
        this.ShortName = "";
        this.CatId = 0;
        this.DeptId = 0;
        this.SubCatId = 0;
        this.BrandId = 0;
        this.UnitId = 0;
        this.ColorId = 0;
        this.SizeId = 0;
        this.PackingQty = "";
        this.CostPrice = 0;
        this.SellingPrice = 0;
        this.AvgCost = 0;
        this.LastPurCost = 0;
        this.StkQty = 0;
        this.Margin = 0;
        this.MarginPer = 0;
        this.Barcode = "";
        this.ItemImagepath = "";
        this.ItemImageBinary = new Object;
        this.SecLanguage = "";
        this.IsRowMaterial = false;
        this.IsStockItem = false;
        this.IsWeightItem = false;
        this.IsActive = true;
        this.UserId = 1;
        this.supplier = 0;
        this.Taxcode = 0;
        this.TaxRate = 0;
        this.Alternateunit = [];
        this.ItemControl = [];
        this.OrderLevel = [];
        this.Supplieritem = [];
        this.SellingPriceList = [];
        this.IsExpiry=false;
        this.IsSerialItem=false;
        this.IsCalculateStock=true;
        this.ImageWidth=0;
        this.ImageHeight=0;
    }
}
export class Alternateunit_Model implements IAlternateunit {
    ID: number;
    description: string;
    unitid: number;
    conversion: string;
    costprice: number;
    sellingprice: number;
    barcode: string;
    itemimagePath: string;
    itemimagebinary: object;
    secondarylanguagename: string;
    Unit: string;
    constructor() {
        this.ID = 0;
        this.description = "";
        this.unitid = 0;
        this.conversion = "";
        this.costprice = 0.00;
        this.sellingprice = 0;
        this.barcode = "";
        this.itemimagePath = "";
        this.itemimagebinary = new Object;
        this.secondarylanguagename = "";
        this.Unit = "";
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/interface/Product_MasterView.ts